import { render } from "./PanelOption.vue?vue&type=template&id=27d51a5a&lang=pug"
import script from "./PanelOption.vue?vue&type=script&lang=js"
export * from "./PanelOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__